import { useEffect } from "react"
import "./App.css"
import Router from "./components/Router.js"
import axios from "axios"

function App() {
  return (
    <div className="app-container">
      <Router></Router>
    </div>
  )
}

export default App
